import { UIEvent } from "react";

export default function resetClippedContainerScroll(
  event: UIEvent<HTMLElement>,
): void {
  const element = event.currentTarget;

  if (element.scrollLeft !== 0) {
    element.scrollLeft = 0;
  }

  if (element.scrollTop !== 0) {
    element.scrollTop = 0;
  }
}
